/*
 * @Author: songge
 * @Date: 2020-08-31 16:13:51
 * @LastEditTime: 2020-08-31 19:21:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \demo9\51-demo\src\_zbzt_live_sdk\src\network\commonFetch.js
 */
import axios from 'axios';
/**
 * 真正的请求
 * @param url 请求地址
 * @param options 请求参数
 * @param method 请求方式
 */

const get = (params, url, timeout, headers) => {
  return axios({
    method: 'get',
    url,
    timeout,
    params,
    headers
  });
};

const post = (data, url, timeout) => {
  return axios({
    method: 'post',
    url,
    timeout,
    data
  });
};

const post1 = (data, url, timeout, headers) => {
  const qs = new URLSearchParams();
  for (const key in data) {
    qs.append(key, encodeURIComponent(data[key]));
  }
  return axios({
    method: 'post',
    url,
    timeout,
    data: qs.toString(),
    headers
  });
};
function commonFetch(url, options, method = 'GET', timeOut = 60000, headers) {
  if (method === 'GET') { // 如果是GET请求，拼接url
    return get(options, url, timeOut, headers).then((res)=>{
      return res.data;
    });
  } else if(method === 'POST')  {
    return post(options, url, timeOut).then((res)=>{
      return res.data;
    });
  } else if(method === 'FROMDATA') {
    let  headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    };
    return post1(options, url, timeOut, headers).then((res)=>{
      return res.data;
    });
  }
}

export default commonFetch;

